/**
 * Canonical gate for the Method Intro module.
 *
 * Resolves Entitlement → Workspace module → Module policy → Personal flag
 * via the one policy-aware gate (build contract §2.7). Never check
 * isModuleEnabled/isFeatureEnabled inline for the intro/tour — use this.
 *
 * Gates only the first-run teaser and /method/tour. The permanent /method
 * reference pages (phase explanations, object types, toolbox) are not
 * gated — they're always reachable from navigation.
 */

import { useModuleGate } from '../../../lib/moduleGate';

export function useMethodIntroEnabled(): boolean {
  return useModuleGate('method_intro');
}
